import { effects } from './effects';
import { middleware } from './middleware';
import { exportModule } from './module';
import { state } from './state';

// for non-composeApp peeps
export { ldInitialize, ILaunchDarklyParams } from '@opengov/launchdarkly';

export const FeatureFlagModule = exportModule({
  state,
  effects,
  middleware
});
